import React, { useState } from 'react'
import { useGetAllSurveyCategoriesQuery } from '../../app/surveyApi/surveyCategoryApi'
import Button from '../../components/shared/buttons/button'
import { useNavigate } from 'react-router'
import Datatable from '../../components/shared/datatable/Datatable'
import { formatDateToMDY } from '../../helpers/Utils'
import { MdOutlineEditNote, MdDeleteOutline } from 'react-icons/md'
import AddSurveyCategoryModal from '../../components/shared/modalContent/AddSurveyCategoryModal'
import { AiOutlineEye } from 'react-icons/ai'
import { Image } from 'react-bootstrap'
const SurveyCategory = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState("") 
    const [surveyCategoryId,setSurveyCategoryId] = useState(null)
    console.log(surveyCategoryId,"surveyCategoryId");
    const handlePageChange = (newPAge) =>{
        setPage(newPAge)
    }
    const { data: categories } = useGetAllSurveyCategoriesQuery({ page, search });
    const [showModal, setShowModal] = useState(false);

    const columns = [
        {
            accessor: "survey_category_title",
            label: "Survey Category",
            cell :({row}) =>{
                return(
           
                    <div className='d-flex gap-2 align-items-center'>
                        <Image src={row?.category_image} className='rounded object-fit-cover' alt="picture" width={40} height={40}/>
                        <p className='mb-0'>{row?.survey_category_title}</p>
                    </div>
                )
            }
        },
        {
            accessor: "createdAt",
            label: "Created",
            cell: ({ row }) => {
                return (
                    <>
                        {formatDateToMDY(row?.createdAt)}
                    </>
                )
            }
        },
        {
            accessor: "updatedAt",
            label: "Updated",
            cell: ({ row }) => {
                return (
                    <>
                        {formatDateToMDY(row?.updatedAt)}
                    </>
                )
            }
        },
        {
            accessor: "action",
            label: "Action",
            cell: ({ row }) => {
                return (
                    <div className='d-flex gap-3'>
                        <Button onClick={()=>{setSurveyCategoryId(row?._id);setShowModal(true)}} className={'borderedBtn'} size={'xs'} icon={<MdOutlineEditNote size={24} />
                        } />
                        <Button
                            className={'borderedBtn'}
                            size={'xs'}
                            onClick={()=>{navigate(`/survey-category/survey/${row?._id}`)}}
                            icon={<AiOutlineEye size={24} />} // Replace with delete icon like <MdDelete />
                        />
                    </div>
                )
            }
        }
    ]
    return (
        <>
            <div className="d-flex justify-content-between mb-3 align-items-center">
                <h6 className='mb-0 cmn_heading'>Survey Categories</h6>
                <Button label="Add Category" size="xs" onClick={() => { setSurveyCategoryId(null); setShowModal(true); }} />
            </div>

            <Datatable
                columns={columns}
                tableData={categories?.data}
                onPageChange={handlePageChange}
            />

            <AddSurveyCategoryModal show={showModal} setShow={setShowModal} handleClose={() => setShowModal(false)} surveyCategoryId={surveyCategoryId}/>
        </>
    )
}

export default SurveyCategory